<template>

  <div>
    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      @updateFilter="updatedFilter($event)"
    />
    <!-- <users-list-filters
      :status-filter.sync="statusFilter"
      :category-filter.sync="categoryFilter"
      :categories-options="categoriaOptions"
      @updateFilter="updatedFilter($event)"
    /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                v-if="$can('create', 'Vendedor')"
                variant="outline-info"
                class="mr-1"
                v-b-modal.modal-api-documentation
              >
                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="CodeIcon"
                    size="16"
                  />
                  API
                </span>
              </b-button>
              <b-button
                  v-if="$can('create', 'Vendedor')"
                variant="primary"
                @click="$router.push({ name: 'app-adm-produto-add' })"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Produto
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="findAll"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(item_nome)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.item_nome)"
                :src="data.item.imagens.length > 0 ? data.item.imagens[0].caminho_imagem : null"
              />
            </template>
            <a
              :href="`${getProdutoBaseUrl()}/${data.item.id}`"
              target="_blank"
              class="font-weight-bold d-block text-nowrap link-produto"
              style="color: inherit; cursor: pointer;"
            >
              {{ data.item.item_nome.length > 30 ? data.item.item_nome.substring(0, 30) + '...' : data.item.item_nome }}
            </a>
          </b-media>
        </template>

        <template #cell(preco)="data">
          <span
            v-if="data.item.tabela_preco_itens.length > 0"
            class="text-nowrap"
          >
            {{ data.item.tabela_preco_itens[0].preco_venda | currency }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            {{ data.item.preco_venda | currency }}
          </span>
        </template>

        <template #cell(categoria)="data">
          <span
            v-if="data.item.categoria"
            class="text-nowrap"
          >
            {{ data.item.categoria.nome }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            -
          </span>
        </template>

        <template #cell(data_inclusao)="data">
          <span class="text-nowrap">
            {{ data.item.data_inclusao | formatDateTimeBr }}
          </span>
        </template>

        <template #cell(comissao)="data">
          <span class="text-nowrap">
            {{ data.item.comissao | formatComissao }}
          </span>
        </template>


        <!-- Column: Id -->
        <template #cell(id)="data">
          <b-link
            :to="{ name: 'app-adm-produto-view', params: { id: data.item.id }}"
            class="font-weight-bold"
          >
            #{{ data.item.id }}
          </b-link>
        </template>

        <template #cell(item_descricao)="data">
          <span v-html="data.value" />
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : data.item.ativo === 0 ? 'Inativo' : 'Deletado' }}
          </b-badge>
        </template>
        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('read', 'Vendedor')"
              v-ripple.400="hasPrice(data.item) ? 'rgba(113, 102, 240, 0.15)' : ''"
              v-b-tooltip.hover.top="hasPrice(data.item) ? 'Visualizar' : 'Produto sem preço definido'"
              size="20"
              :style="{
                color: hasPrice(data.item) ? 'var(--secondary)' : '#b8c2cc',
                opacity: hasPrice(data.item) ? '1' : '0.5',
                cursor: hasPrice(data.item) ? 'pointer' : 'not-allowed'
              }"
              icon="EyeIcon"
              class="icon-activity"
              @click.stop="hasPrice(data.item) ? viewProduto(data.item.id) : $event.preventDefault()"
            />
            <feather-icon
                v-if="$can('update', 'Vendedor')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editCliente(data.item.id)"
            />
            <feather-icon
                v-if="$can('delete', 'Vendedor')"
              v-ripple.400="data.item.comprado ? '' : 'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="data.item.comprado ? 'Produto já foi comprado e não pode ser excluído' : 'Deletar'"
              v-b-modal="data.item.comprado ? '' : 'modal-confirme-delete-cliente'"
              size="20"
              :style="{
                color: data.item.comprado ? '#b8c2cc' : 'var(--danger)',
                opacity: data.item.comprado ? '0.5' : '1',
                cursor: data.item.comprado ? 'not-allowed' : 'pointer'
              }"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="data.item.comprado ? $event.preventDefault() : (idProduto = data.item.id)"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalClientes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-cliente"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir esse cliente?"
      @ok="deleteCategory"
    />

    <!-- Modal API Documentation -->
    <b-modal
      id="modal-api-documentation"
      title="Manual de Importação de Produtos via API"
      size="lg"
      ok-only
      ok-title="Fechar"
      ok-variant="secondary"
      scrollable
    >
      <div class="api-documentation">
        <div class="api-hero d-flex align-items-center mb-3">
          <div class="api-hero__icon d-flex align-items-center justify-content-center mr-2">
            <feather-icon icon="UploadCloudIcon" size="24" />
          </div>
          <div class="flex-fill">
            <h5 class="mb-1">Importação em massa via API</h5>
            <p class="mb-0 text-muted">Envie produtos rapidamente com um payload único. Use seu token de acesso e o ID do vendedor abaixo.</p>
          </div>
          <b-badge variant="light-success" class="font-weight-bold text-success">REST</b-badge>
        </div>

        <div class="info-chips mb-3">
          <div class="info-chip">
            <small class="text-uppercase text-muted">ID do vendedor</small>
            <div class="d-flex align-items-center mt-1">
              <code class="font-weight-bold">{{ idVendedor || 'Carregando...' }}</code>
              <span class="text-muted ml-2">(na URL)</span>
            </div>
          </div>
          <div class="info-chip">
            <small class="text-uppercase text-muted">Autenticação</small>
            <div class="d-flex align-items-center mt-1">
              <feather-icon icon="ShieldIcon" size="16" class="text-success mr-1" />
              <span>Bearer Token (via login)</span>
            </div>
          </div>
          <div class="info-chip">
            <small class="text-uppercase text-muted">Formato</small>
            <div class="d-flex align-items-center mt-1">
              <feather-icon icon="FileTextIcon" size="16" class="text-primary mr-1" />
              <span>JSON</span>
            </div>
          </div>
        </div>

        <div class="quick-steps card-grid mb-3">
          <div class="card-grid__item">
            <div class="d-flex align-items-center mb-1">
              <span class="step-badge">1</span>
              <strong>Obtenha seu token</strong>
            </div>
            <p class="text-muted mb-0">Faça login para receber um Bearer Token válido por 24h.</p>
          </div>
          <div class="card-grid__item">
            <div class="d-flex align-items-center mb-1">
              <span class="step-badge">2</span>
              <strong>Monte o payload</strong>
            </div>
            <p class="text-muted mb-0">Preencha os campos mínimos (nome e categoria) e inclua imagens se já tiver IDs.</p>
          </div>
          <div class="card-grid__item">
            <div class="d-flex align-items-center mb-1">
              <span class="step-badge">3</span>
              <strong>Envie para o endpoint</strong>
            </div>
            <p class="text-muted mb-0">Use seu <code>id_vendedor</code> na URL e o token no header Authorization.</p>
          </div>
          <div class="card-grid__item">
            <div class="d-flex align-items-center mb-1">
              <span class="step-badge">4</span>
              <strong>Revise o retorno</strong>
            </div>
            <p class="text-muted mb-0">Sucessos são criados mesmo que outros itens falhem. Veja os erros por índice.</p>
          </div>
        </div>

        <!-- NOVO: Seção de Autenticação -->
        <div class="card-grid mb-3">
          <div class="card-grid__item flex-fill">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6 class="mb-0 text-secondary">Passo 1: Obtenha seu Token</h6>
              <b-badge variant="light-info">LOGIN</b-badge>
            </div>
            <p class="text-muted small mb-2">Faça login para receber um token de acesso válido por 24 horas.</p>
            <div class="api-code small">
              <pre class="mb-0"><code><strong>POST</strong> https://api.avmarket.com.br/api/auth/login

    {
      "login": "seu_email@example.com",
      "senha": "sua_senha",
    }</code></pre>
            </div>
          </div>
          <div class="card-grid__item tips-card">
            <h6 class="mb-2 text-secondary">Resposta do Login</h6>
            <div class="api-code small">
              <pre class="mb-0"><code>{
      "id": 123,
      "login": "seu_email@...",
      "accessToken": "eyJ...",
      "refreshToken": "eyJ...",
      "vendedor": { 
        "id": 456 
      },
      ...
    }</code></pre>
            </div>
            <small class="text-muted mt-2 d-block"><strong>Copie:</strong> o valor de <code>accessToken</code> para usar abaixo.</small>
          </div>
        </div>

        <!-- Endpoint e Headers -->
        <div class="card-grid mb-3">
          <div class="card-grid__item">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6 class="mb-0 text-secondary">Passo 2: Endpoint</h6>
              <b-badge variant="light-primary">POST</b-badge>
            </div>
            <div class="api-code"><pre class="mb-0"><code>https://api.avmarket.com.br/api/v1/vendedor/{id_vendedor}/items/import</code></pre></div>
            <small class="text-muted">Substitua <code>{id_vendedor}</code> pelo ID exibido acima.</small>
          </div>
          <div class="card-grid__item">
            <h6 class="mb-2 text-secondary">Headers</h6>
            <div class="api-code">
              <pre class="mb-0"><code>{
      "Content-Type": "application/json",
      "Authorization": "Bearer SEU_ACCESS_TOKEN"
    }</code></pre>
            </div>
            <small class="text-muted">Cole o <code>accessToken</code> obtido no login acima.</small>
          </div>
        </div>

        <!-- Body -->
        <div class="card-grid mb-3">
          <div class="card-grid__item flex-fill">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6 class="mb-0 text-secondary">Passo 3: Body (payload)</h6>
              <b-badge variant="light-warning" class="text-warning">Envie em lote</b-badge>
            </div>
            <div class="api-code">
              <pre class="mb-0"><code>{
      "items": [
        {
          "item_nome": "Nome do Produto",
          "item_descricao": "&lt;p&gt;Descrição detalhada&lt;/p&gt;",
          "quantidade": 100,
          "comissao": 10.50,
          "id_categoria": 5,
          "ativo": 1,
          "comprimento": 10.5,
          "largura": 5.25,
          "altura": 15.75,
          "peso": 2.5,
          "valor_frete": 12.5,
          "embalagem": 1,
          "id_imagem_item": 123
        }
      ]
    }</code></pre>
            </div>
          </div>
          <div class="card-grid__item tips-card">
            <h6 class="mb-2 text-secondary">Dicas rápidas</h6>
            <ul class="list-unstyled mb-0 text-muted small">
              <li class="mb-1">• Campos de medidas são opcionais, mas ajudam no frete.</li>
              <li class="mb-1">• Se não enviar <code>ativo</code>, o item entra como ativo.</li>
              <li class="mb-1">• Utilize <code>id_imagem_item</code> apenas após subir imagens.</li>
              <li>• Envie vários itens no mesmo array para ganhar tempo.</li>
            </ul>
          </div>
        </div>

        <div class="mb-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="mb-0 text-secondary">Categorias disponíveis</h6>
            <b-button size="sm" variant="outline-secondary" @click="showCategorias = !showCategorias">
              {{ showCategorias ? 'Esconder' : 'Visualizar' }} ({{ categoriasItems.length }})
            </b-button>
          </div>
          <b-collapse v-model="showCategorias">
            <div class="border rounded bg-white shadow-sm" style="max-height: 200px; overflow-y: auto;">
              <div v-if="categoriasItems && categoriasItems.length > 0">
                <table class="table table-sm table-hover mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th style="width: 60px;">ID</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="categoria in categoriasItems" :key="categoria.id">
                      <td><code class="text-muted">{{ categoria.id }}</code></td>
                      <td><small>{{ categoria.nome }}</small></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center text-muted py-2">
                <small>Carregando...</small>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="mb-3">
          <h6 class="text-secondary mb-2">Descrição dos Campos</h6>
          <div class="border rounded shadow-sm">
            <table class="table table-sm table-hover mb-0">
              <thead class="bg-light">
                <tr>
                  <th>Campo</th>
                  <th style="width: 100px;">Tipo</th>
                  <th style="width: 90px;">Obrigatório</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>item_nome</code></td>
                  <td><small>String</small></td>
                  <td><small class="text-danger">Sim</small></td>
                </tr>
                <tr>
                  <td><code>item_descricao</code></td>
                  <td><small>Text/HTML</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>quantidade</code></td>
                  <td><small>Integer</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>comissao</code></td>
                  <td><small>Decimal</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>id_categoria</code></td>
                  <td><small>Integer</small></td>
                  <td><small class="text-danger">Sim</small></td>
                </tr>
                <tr>
                  <td><code>ativo</code></td>
                  <td><small>0 ou 1</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>comprimento, largura, altura</code></td>
                  <td><small>Decimal</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>peso</code></td>
                  <td><small>Decimal</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>valor_frete</code></td>
                  <td><small>Decimal</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>embalagem</code></td>
                  <td><small>Integer</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
                <tr>
                  <td><code>id_imagem_item</code></td>
                  <td><small>Integer</small></td>
                  <td><small class="text-muted">Não</small></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-grid mb-3">
          <div class="card-grid__item">
            <h6 class="mb-2 text-secondary">Exemplo de Sucesso</h6>
            <div class="api-code small">
              <pre class="mb-0"><code>{
      "total": 2,
      "successCount": 2,
      "errorCount": 0,
      "successes": [
        {
          "id": 101,
          "item_nome": "Produto A",
          "id_vendedor": 123
        }
      ],
      "errors": []
    }</code></pre>
            </div>
          </div>
          <div class="card-grid__item">
            <h6 class="mb-2 text-secondary">Exemplo com Erros</h6>
            <div class="api-code small">
              <pre class="mb-0"><code>{
      "total": 2,
      "successCount": 1,
      "errorCount": 1,
      "errors": [
        {
          "index": 1,
          "error": "Item já cadastrado"
        }
      ]
    }</code></pre>
            </div>
          </div>
        </div>

        <div class="alert alert-light border">
          <small class="text-muted">
            <strong>Observações:</strong>
            <ul class="mb-0 pl-3 mt-1">
              <li>Itens válidos são criados mesmo que outros falhem.</li>
              <li><code>uuid</code>, <code>data_inclusao</code> e <code>data_alteracao</code> são preenchidos automaticamente.</li>
              <li>Erro por <code>index</code> indica a posição do item com falha no array enviado.</li>
              <li>O token obtido no login é válido por 24h. Após expirar, faça login novamente.</li>
            </ul>
          </small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip, BModal, BTableSimple, BThead, BTbody, BTr, BTh, BTd, BAlert, BCollapse,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onMounted,
} from '@vue/composition-api'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import useProdutosList from '@/views/apps/produtos/list/useProdutosList'
import router from '@/router'
import { currency, formatDateTimeBr, avatarText } from '@core/utils/filter'
import { useApi } from '@/composables/useApi'
import UsersListFilters from './ItemProdutoListFilters.vue'

export default {
  components: {
    UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
    BModal,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BAlert,
    BCollapse,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  filters: {
    currency,
    formatDateTimeBr,
    formatComissao(value) {
      if (!value) return '0%'
      const [inteiro, decimal] = value.toString().split('.')
      return decimal === '00' || !decimal ? `${inteiro}%` : `${inteiro},${decimal}%`
    },
  },
  setup() {
    const toast = useToast()
    const api = useApi()
    const idProduto = ref(null)
    const categoriasItems = ref([])
    const idVendedor = ref(null)
    const showCategorias = ref(false)
    const blankCategoryData = ref({
      id: null,
      item_nome: '',
      item_descricao: '',
      id_categoria: '',
      ativo: 1,
      imagens: [],
    })

    const {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      categoriaOptions,
      categoryFilter,
    } = useProdutosList()

    const gruposOptions = ref([])

    const getProdutoBaseUrl = () => {
      const mode = process.env.MODE_APP
      if (mode === 'prod') {
        return 'https://avmarket.com.br/produto'
      }
      return 'https://hml.avmarket.com.br/produto'
    }

    const updatedFilter = e => {
      if (e.status !== undefined) {
        statusFilter.value = e.status
      }
      if (e.id_categoria !== undefined && e.id_categoria !== null) {
        const categoria = JSON.parse(JSON.stringify(e.id_categoria))
        categoryFilter.value = categoria.id
      }
      refetchData()
    }

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addCliente = async () => {
      blankCategoryData.value = {
        id: null,
        item_nome: '',
        item_descricao: '',
        id_categoria: '',
        ativo: 1,
        imagens: [],
      }
      isAddNewUserSidebarActive.value = true
    }

    const editCliente = id => {
      router.push({ name: 'app-adm-produto-add', params: { id } })
    }

    const viewProduto = id => {
      router.push({ name: 'app-adm-produto-view', params: { id } })
    }

    const hasPrice = item => {
      // Verifica se tem preço na tabela de preços
      if (item.tabela_preco_itens && item.tabela_preco_itens.length > 0) {
        return item.tabela_preco_itens[0].preco_venda && item.tabela_preco_itens[0].preco_venda > 0
      }
      // Verifica se tem preço direto no item
      return item.preco_venda && item.preco_venda > 0
    }

    const deleteCategory = async () => {
      await store.dispatch('appAdmProdutos/delete', { id: idProduto.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idProduto.value = null
          refetchData()
        })
      refetchData()
    }

    onMounted(() => {
      store.dispatch('appAdmProdutos/findAll')
      
      // Busca o id_vendedor do usuário logado
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (userData && userData.id) {
        idVendedor.value = userData.id
      }
      
      // Busca as categorias disponíveis
      api.get('/categorias')
        .then(response => {
          const { categories } = response.data
          categoriasItems.value = categories
        })
        .catch(error => {
          console.error('Erro ao buscar categorias:', error)
        })
    })
    return {
      idProduto,
      addCliente,
      blankCategoryData,
      editCliente,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      getProdutoBaseUrl,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      updatedFilter,
      deleteCategory,
      viewProduto,
      hasPrice,
      categoriaOptions,
      categoryFilter,
      
      // API Documentation
      categoriasItems,
      idVendedor,
      showCategorias,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.link-produto {
  transition: color 0.2s;
  &:hover {
    color: #007bff !important;
    text-decoration: underline;
  }
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}

.api-documentation {
  background: linear-gradient(180deg, #f8fafc 0%, #f4f6fa 100%);
  border-radius: 8px;
  padding: 8px;

  pre {
    background-color: #0b1524;
    color: #e5edf7;
    padding: 1rem;
    border-radius: 8px;
    overflow-x: auto;
    margin: 0;
  }

  code {
    font-size: 0.875rem;
  }
}

.api-hero {
  background: linear-gradient(120deg, #f1f5ff 0%, #eefaf6 100%);
  border: 1px solid #e6ecf5;
  border-radius: 10px;
  padding: 16px;
}

.api-hero__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e6ecf5;
  color: #4d7cff;
}

.info-chips {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.info-chip {
  background: #fff;
  border: 1px solid #e6ecf5;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.06);
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
}

.card-grid__item {
  background: #fff;
  border: 1px solid #e6ecf5;
  border-radius: 10px;
  padding: 14px;
  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.06);
  height: 100%;
}

.api-code {
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  background: #0b1524;
  color: #e5edf7;
  border-radius: 10px;
  border: 1px solid #0f1f35;
  padding: 10px 12px;
  line-height: 1.35;
  white-space: pre;
  overflow-x: auto;
}

.step-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4d7cff, #38c4a7);
  color: #fff;
  font-weight: 700;
  margin-right: 8px;
  box-shadow: 0 6px 16px rgba(77, 124, 255, 0.35);
}

.tips-card {
  background: #fffdf5;
  border-color: #ffe9b3;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
